import axios from "axios";

export const resolveBackendUrl = (value = process.env.REACT_APP_BACKEND_URL) => {
  const raw = String(value || "").trim().replace(/\/+$/, "");
  return raw.replace(/\/api$/i, "") || "";
};

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const detailText = (item) => {
  if (typeof item === "string") return item;
  if (!item || typeof item !== "object") return "";
  return item.msg || item.error || item.message || "";
};

const locToField = (loc) => {
  const parts = Array.isArray(loc) ? loc : String(loc || "").split(".");
  return parts
    .filter((part) => part !== "body" && part !== "query" && part !== "path")
    .map(String)
    .filter(Boolean)
    .join(".");
};

const collectFieldErrors = (detail) => {
  const fieldErrors = {};
  const items = Array.isArray(detail) ? detail : [detail];
  items.forEach((item) => {
    if (!item || typeof item !== "object") return;
    const field = item.field || locToField(item.loc);
    const message = detailText(item);
    if (field && message && !fieldErrors[field]) fieldErrors[field] = message;
  });
  return fieldErrors;
};

export const parseApiError = (err, fallback = "Lỗi") => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return { message: detail, fieldErrors: {} };

  const fieldErrors = collectFieldErrors(detail);
  const firstFieldError = Object.values(fieldErrors)[0];
  const message = detailText(detail) || firstFieldError || fallback || err?.message;
  return { message, fieldErrors };
};

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ts_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("ts_token");
      localStorage.removeItem("ts_user");
      if (!window.location.pathname.endsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const fmtMoney = (n) =>
  new Intl.NumberFormat("vi-VN").format(Number(n || 0)) + " ₫";

export const fmtNumber = (n) =>
  new Intl.NumberFormat("vi-VN").format(Number(n || 0));

export const fmtDate = (s) => {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("vi-VN");
  } catch { return s; }
};

export const fmtDateTime = (s) => {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleString("vi-VN", { dateStyle: "short", timeStyle: "short" });
  } catch { return s; }
};
